/**
 * Generate Grafana Dashboard URL via PHP Proxy
 *
 * This function creates URLs that point to the PHP proxy endpoint instead of directly to Grafana.
 * The proxy handles authentication server-side, avoiding browser restrictions on embedded credentials.
 *
 * @param {Object} params - URL generation parameters
 * @returns {string} - Complete proxy URL
 */
export function generateProxyUrl({
  dashboardPath,
  campaignName = "ALL",
  medium = "All",
  theme = "light",
  shortCode = "All",
  days = "10",
  orgId = "1",
  labels = "All",
  from = "now-7d",
  to = "now",
  source = "All",
}) {
  // Use the PHP backend proxy endpoint
  const proxyBaseUrl = process.env.REACT_APP_API_URL + "/grafana/proxy.php";

  const params = {
    path: dashboardPath,
    orgId: orgId,
    "var-Days": days,
    "var-CampaignName": campaignName,
    "var-Source": source,
    "var-Medium": medium,
    "var-Labels": labels,
    "var-ShortCode": shortCode,
    from: from,
    to: to,
    theme: theme,
    // Add kiosk mode to hide Grafana UI and reduce API calls
    kiosk: "tv",
  };

  try {
    const url = new URL(proxyBaseUrl);

    for (const key in params) {
      if (Array.isArray(params[key])) {
        params[key].forEach((value) => url.searchParams.append(key, value));
      } else {
        url.searchParams.append(key, params[key]);
      }
    }

    return url.toString();
  } catch (error) {
    console.error("Invalid URL or parameters:", error);
    return null;
  }
}

/**
 * Extract dashboard path from full Grafana URL
 *
 * @param {string} fullUrl - Full Grafana dashboard URL
 * @returns {string} - Dashboard path (e.g., "/d/xxx/dashboard-name")
 */
export function extractDashboardPath(fullUrl) {
  try {
    const url = new URL(fullUrl);
    return url.pathname + url.search;
  } catch (error) {
    console.error("Invalid Grafana URL:", error);
    return "";
  }
}
